'use client'
import { FormDatePickerProps, FormDatePicker } from '../../../FormElements'
import { useFilterContext } from '../../../../providers/filter-provider'
import { FilterOperator } from '../../../../types/Filters'
import React from 'react'
import { useEffect, useState } from 'react'
import { FilterItem } from '../FilterItem'

export interface DateFilterProps extends Omit<FormDatePickerProps, 'value' | 'name' | 'id' | 'onChange'> {
    /** "name" of object that should be filtered on. Will be used to create unique ID for "Filter" Object. This should be exactly the key that the API needs to filter on */
    name: string
    label: string
    operator: FilterOperator
    fieldName: string
}

export const DateFilter = ({
    label,
    name,
    operator = FilterOperator.GREATER_THAN_OR_EQUAL,
    fieldName,
    ...props
}: DateFilterProps): JSX.Element => {
    const { filters, registerFilter, updateFilterValue, getFilterId, getFilterValue, getFilterById } =
        useFilterContext()
    const filterId = getFilterId(name, operator)
    const defaultValue = getFilterValue(filterId)
    const formattedDefaultValue = (
        defaultValue && typeof defaultValue === 'string' ? new Date(defaultValue) : defaultValue
    ) as Date
    const [selectedValue, setSelectedValue] = useState<Date | null | undefined>(formattedDefaultValue)

    useEffect(() => {
        registerFilter({
            id: filterId,
            key: name,
            operator: operator,
            value: selectedValue,
        })
    }, [])

    useEffect(() => {
        const filter = getFilterById(filterId)
        if (filter) {
            updateFilterValue({ filter: filter, newValue: selectedValue })
        }
    }, [selectedValue])

    useEffect(() => {
        const filter = getFilterById(filterId)
        if (filter) {
            const matchingFilter = filters.find((stateFilter) => stateFilter.id === filter.id)
            if (matchingFilter) {
                if (matchingFilter.value === (null || undefined)) {
                    //@ts-ignore
                    setSelectedValue(matchingFilter.value)
                } else if (
                    matchingFilter?.value instanceof Date &&
                    selectedValue?.getTime() !== matchingFilter?.value?.getTime()
                ) {
                    setSelectedValue(matchingFilter.value)
                }
            }
        }
    }, [filters])

    return (
        <FilterItem>
            <FormDatePicker
                {...props}
                name={fieldName}
                defaultDate={selectedValue}
                onChange={(date: Date | null) => setSelectedValue(date)}
                id={fieldName}
                placeholderText="DD/MM/YYYY"
            />
        </FilterItem>
    )
}
